export var UserTestStatus;
(function (UserTestStatus) {
    UserTestStatus["Pending"] = "PENDING";
    UserTestStatus["Active"] = "ACTIVE";
    UserTestStatus["Paused"] = "PAUSED";
})(UserTestStatus || (UserTestStatus = {}));
